import React, { useContext, useEffect, useState } from 'react'
import Footer from '../Components/Footer'
import Header from '../Components/Header'
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../api';
import { baseUrl, path } from '../constants';
import { Oval } from 'react-loader-spinner'
import { settingsContext } from '../Context/settingsProvider';

export default function VerifyPayment() {
    const {id} = useParams()
    const navigate = useNavigate()
    const [error, setError] = useState(false)
    const {t} = useContext(settingsContext)

    useEffect(() => {
        api.get(path.verifyPayment + '/' + id).then(response => {
            let data = response.data
            if(data.success) return navigate('/learn/' + id + '?payment=true')
            else setError(true)
        })
    }, [])

    return (
        <div className='w-full h-screen flex flex-col pt-[60px]'>
        <Header withLogo />
        <div className='flex-1 flex'>
            <div className='flex-1 flex flex-col items-center p-12 gap-5'>
                <h1 className='text-black text-[25px] font-bold'>{t('CHEKOUT')}</h1>
                <p>{error ? 'Payment Not Verified. Please contact support!' : t('VERIFYING')}</p>
                {!error && <Oval
                    visible={true}
                    height="50"
                    width="50"
                    color="#6622cf"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    strokeWidth={3}
                /> }
            </div>
           
        </div>
        <Footer />
        </div>
    )
}